<template>
  <div class="col-md-4 col-sm-6 dashboard-item">
    <div class="card bg">
      <div class="row">
        <div class="col-12">
          <div class="text-primary p-3" v-if="addedClientId">
            <h3>Congratulations!</h3>
            <p>{{ successMessage }}</p>
            <button class="btn btn-primary mt-4 container-fluid" v-on:click="login">{{ content['addClient.loginButton'] }}</button>
            <button class="btn btn-dark mt-4 container-fluid" v-on:click="reset">{{ content['addClient.addAnotherButton'] }}</button>
          </div>
          <div class="text-primary p-3" v-else>
            <h3>ADD NEW CLIENT</h3>
            <form @submit.prevent="register" class="form" autocomplete="off">
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="first_name">First Name</label>
                    <input class="form-control" type="text" name="first_name" v-model="clientName.firstName" autocomplete="off">
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="last_name">Last Name</label>
                    <input class="form-control" type="text" name="last_name" v-model="clientName.lastName" autocomplete="off">
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="email">Email</label>
                    <input class="form-control" type="text" name="email" v-model="email" autocomplete="off">
                  </div>
                  <div class="form-group">
                    <label for="phone">Phone</label>
                    <input class="form-control" type="phone" name="phone" v-model="phone" autocomplete="off">
                  </div>
                  <div class="form-group">
                    <label for="address">Address</label>
                    <input class="form-control" type="text" name="address" v-model="address" autocomplete="off">
                  </div>
                  <div class="form-group">
                    <label for="city">City</label>
                    <input class="form-control" type="text" name="city" v-model="city" autocomplete="off">
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="state">State</label>
                    <select class="form-control" v-model="state">
                      <optgroup v-for="(states, letter) in groupedStates" :label="letter" :key="letter">
                        <option v-for="s in states" :key="s" :value="s">{{ s }}</option>
                      </optgroup>
                    </select>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="postal_code">Postal Code</label>
                    <input class="form-control" type="text" name="postal_code" v-model="postalCode" autocomplete="off">
                  </div>
                </div>
              </div>
              <div v-for="(registerErrorMessage, index) in registerErrorMessages" :key="index">
                <error-message :errorMessage="registerErrorMessage"></error-message>
              </div>
              <div class="form-group text-center">
                <button class="btn btn-primary mt-4 container-fluid" type="submit">
                  <span v-if="!loadingMessage">Create Account</span>
                  <loading v-if="loadingMessage" :message="loadingMessage"></loading>
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import api from '@/services/api'
import Loading from './Loading'
import ErrorMessage from './shared/error-message'

const US_STATES = [
  'Alabama', 'Alaska', 'Arizona', 'Arkansas', 'California', 'Colorado', 'Connecticut', 'Delaware', 'Florida', 'Georgia',
  'Hawaii', 'Idaho', 'Illinois', 'Indiana', 'Iowa', 'Kansas', 'Kentucky', 'Louisiana', 'Maine', 'Maryland', 'Massachusetts',
  'Michigan', 'Minnesota', 'Mississippi', 'Missouri', 'Montana', 'Nebraska', 'Nevada', 'New Hampshire', 'New Jersey',
  'New Mexico', 'New York', 'North Carolina', 'North Dakota', 'Ohio', 'Oklahoma', 'Oregon', 'Pennsylvania', 'Rhode Island',
  'South Carolina', 'South Dakota', 'Tennessee', 'Texas', 'Utah', 'Vermont', 'Virginia', 'Washington', 'West Virginia',
  'Wisconsin', 'Wyoming'
]

export default {
  name: 'register',
  components: { ErrorMessage, Loading },
  data () {
    return {
      clientName: {
        firstName: '',
        lastName: ''
      },
      email: '',
      phone: '',
      address: '',
      city: '',
      state: '',
      postalCode: '',
      registerErrorMessages: '',
      loadingMessage: '',
      addedClientId: '',
      content: this.$store.state.il8nContent
    }
  },
  computed: {
    successMessage () {
      return this.$helpers.dynamicContent(this.content['addClient.successMessage'], this.clientName)
    },
    groupedStates () {
      const groups = {}
      US_STATES.forEach(state => {
        const letter = state[0]
        if (!groups[letter]) groups[letter] = []
        groups[letter].push(state)
      })
      return groups
    }
  },
  methods: {
    register () {
      this.registerErrorMessages = ''
      this.loadingMessage = 'Signing Up'
      api.post('/api/stylist/clients', {
        firstName: this.clientName.firstName,
        lastName: this.clientName.lastName,
        email: this.email,
        phone: this.phone,
        address: this.address,
        city: this.city,
        state: this.state,
        postalCode: this.postalCode
      }, {
        headers: {
          'Content-Type': 'application/x.fashionphile.v1+json, application/json'
        }
      }).then(response => {
        this.addedClientId = response.data.data.id
        const clientData = response.data.data.attributes
        clientData.id = this.addedClientId
        this.$store.dispatch('addClientToClients', clientData)
      }).catch(error => {
        this.loadingMessage = ''
        this.registerErrorMessages = error.response.data.errors
      })
    },
    reset () {
      this.clientName = {
        firstName: '',
        lastName: ''
      }
      this.email = ''
      this.phone = ''
      this.address = ''
      this.city = ''
      this.state = ''
      this.postalCode = ''
      this.addedClientId = ''
    },
    login () {
      const data = {
        userId: this.addedClientId,
        url: process.env.VUE_APP_FASHIONPHILE_API_URL + '/account/dashboard'
      }
      this.$store.dispatch('authenticateAndRedirect', data)
    }
  }
}
</script>
